import script from "./GenericTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericTable.vue?vue&type=script&setup=true&lang=js"

import "./GenericTable.vue?vue&type=style&index=0&id=d36eda80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d36eda80"]])

export default __exports__